import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { rememberAffiliate } from '../services/passApi';

/**
 * Watches the route. When the user lands on /pass/:slug (a profile page),
 * the AffiliateProfile component itself persists attribution by slug.
 *
 * This tracker handles the secondary case: when the URL carries ?ref=CODE
 * on any page, we persist the code so a later claim/checkout credits the
 * referring affiliate even if the user wandered out of the /pass space.
 */
export default function AffiliateAttributionTracker() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get('ref');
    if (ref) {
      rememberAffiliate(null, ref);
    }
  }, [location]);

  return null;
}
